export default class EmailVerificationService {
    /* @ngInject */
    constructor(apiService) {
        this.apiService = apiService;
    }

    send(email) {
        return this.apiService.post(`/resend-verification-token`, {
            email
        });
    }

    verify(token) {
        return this.apiService.post(`/verify-user`, {
            token
        });
    }
}



// WEBPACK FOOTER //
// ./src/application/service/user/email-verification.service.js